import { locationPathChanged } from '../../blocks/segments/address/address.events';
import { isMiMO, isSPBiLO, isNNiNGO } from '../../../../shared/utils';
import { TATARSTAN_REGION } from '../../../../shared/constants/regions';

export const MAX_TIME_BY_WALK = 20; // 20 минут

export const getUndergroundDistance = underground => {
  if (!underground) {
    return {};
  }

  const { time, timeByCar, timeByWalk, transportType } = underground;

  if (
    // Отсутствуют поля timeByCar или timeByWalk
    (typeof timeByCar === 'undefined' || typeof timeByWalk === 'undefined') &&
    // но есть поля time и transportType
    typeof time === 'number' &&
    typeof transportType === 'string'
  ) {
    return {
      transportTypeText: transportType === 'walk' ? 'пешком' : 'транспортом',
    };
  }

  if (timeByWalk > MAX_TIME_BY_WALK) {
    return {
      time: timeByCar,
      transportType: 'transport',
      transportTypeText: 'транспортом',
      timeByWalk, // оставляем это поле для для дальнейшей сортировки по удаленности станции от дома
    };
  } else {
    return {
      time: timeByWalk,
      transportType: 'walk',
      transportTypeText: 'пешком',
      timeByWalk, // оставляем это поле для для дальнейшей сортировки по удаленности станции от дома
    };
  }
};

export default [
  '$rootScope',
  function ($rootScope) {
    const service = {
      userGeo: angular.copy(window.addFormState.geo),
    };

    let userDefaultLocationPath = [service.userGeo.id];
    let userDefaultCoordinates = { lat: service.userGeo.lat, lng: service.userGeo.lng };

    let locationPath = [];
    let coordinates = null;

    $rootScope.$on('addform.clear', () => {
      locationPath = [];
      coordinates = null;
    });

    service.setUserGeo = geo => {
      if (geo) {
        Object.assign(service.userGeo, geo);
        userDefaultLocationPath = [service.userGeo.id];
        userDefaultCoordinates = { lat: service.userGeo.lat, lng: service.userGeo.lng };
      }
    };

    service.setLocationPathAndCoordinates = (newLocationPath, newCoordinates) => {
      locationPath = newLocationPath;
      coordinates = newCoordinates;
      $rootScope.$broadcast(locationPathChanged, newLocationPath, newCoordinates);
    };

    service.getLocationPath = () => {
      return locationPath.length ? locationPath : userDefaultLocationPath;
    };

    service.getLocationId = () =>
      locationPath && locationPath.length ? locationPath[locationPath.length - 1] : undefined;

    // Проверка выбора Москвы или Московской области
    service.isMiMO = () => isMiMO(service.getLocationId());

    service.isSPBAndArea = () => isSPBiLO(service.getLocationId());

    service.isNiNo = () => isNNiNGO(service.getLocationId());

    service.isTatarstan = () => service.getLocationId() === TATARSTAN_REGION;

    service.getCoordinates = () => {
      return coordinates || userDefaultCoordinates;
    };

    return service;
  },
];
